import React from 'react';
import { Box } from '@styleseat/ui';
import { Circle } from '../../../ui';
import { NotificationsBellIcon } from '../../../ui/Icons/NotificationsBellIcon';
import PhoneNumberAndConsentFormField from '../../../consumer/appointments/NotifyMeRequest/PhoneNumberAndConsentFormField';

interface NotifyMeRequestForChatFormProps {
  headerText: React.ReactNode;
  optInLanguage: string;
  phoneNumberFooterText: string;
  phoneNumber: string;
  onClickContinue: (phoneNumber: string) => Promise<void>;
}

export const NotifyMeRequestForChatForm: React.FCWithChildren<NotifyMeRequestForChatFormProps> = ({
  headerText,
  optInLanguage,
  phoneNumberFooterText,
  phoneNumber,
  onClickContinue,
}) => (
  <React.Fragment>
    <Box paddingTop={40} paddingBottom={24}>
      <Circle
        diameter={56}
        showBoxShadow
        alignItems="center"
        justifyContent="center"
      >
        <NotificationsBellIcon width={32} height={32} />
      </Circle>
    </Box>
    <Box paddingBottom={24}>
      {headerText}
    </Box>
    <PhoneNumberAndConsentFormField
      consentCheckboxLabel={optInLanguage}
      footerText={phoneNumberFooterText}
      includeTermsLinkInConsentCheckboxLabel
      phoneNumber={phoneNumber}
      onClick={onClickContinue}
    />
  </React.Fragment>
);
